var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"clas":"","s":"loader-container"}},[_c('div',{attrs:{"id":"page-loading"}},[_c('div',{staticClass:"three-balls"},[_c('div',{staticClass:"ball ball1"}),_c('div',{staticClass:"ball ball2"}),_c('div',{staticClass:"ball ball3"})])])])
}]

export { render, staticRenderFns }